'use client';

import { c as _c } from "react/compiler-runtime";
interface OfferPriceProps {
  oldPrice?: number;
  newPrice: number;
  copyTop?: string;
  copyBottom?: string;
}
export const OfferPrice = props => {
  const $ = _c(18);
  const {
    oldPrice,
    newPrice,
    copyBottom,
    copyTop
  } = props;
  let t0;
  if ($[0] !== copyTop) {
    t0 = <p className="text-body-lg">{copyTop}</p>;
    $[0] = copyTop;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== oldPrice) {
    t1 = oldPrice && <span className="text-heading-2 text-bodi-gray-disabled line-through">${oldPrice}</span>;
    $[2] = oldPrice;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== newPrice) {
    t2 = <span className="text-heading-1 leading-none">${newPrice}</span>;
    $[4] = newPrice;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="text-body-md font-medium text-bodi-gray-medium">/mo</span>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2) {
    t4 = <div>{t2}{t3}</div>;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t4) {
    t5 = <div className="flex justify-center gap-1 text-bodi-black-text">{t1}{t4}</div>;
    $[9] = t1;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== copyBottom) {
    t6 = <p className="text-body-sm text-bodi-gray-dark">{copyBottom}</p>;
    $[12] = copyBottom;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t0 || $[15] !== t5 || $[16] !== t6) {
    t7 = <div className="mb-5 flex flex-col gap-2 text-center">{t0}{t5}{t6}</div>;
    $[14] = t0;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};